import { routes } from "../../../constants/routes";
export const breadcrumbLink = [
  {
    label: "View Surveys Form List",
    link: routes.LEADCAPTUREFORM,
    handleClick: () => { },
  },
];


export const breadcrumbLinkResponseList = (setViewOpenForm: any, setCrumbMappingOption: any) => [
    {
      label: "View Surveys Form List",
      link: routes.LEADCAPTUREFORM,
      handleClick: () => {
        setViewOpenForm(false);
        setCrumbMappingOption((prev: any) => prev.slice(0, 1));
      },
    },
    {
      label: "Response Captured",
      link: ""
    }];
